import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/contexts/LanguageContext';

interface CoachmarkSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onDismiss: () => void;
  onHidePoints: () => void;
}

export function CoachmarkSheet({ open, onOpenChange, onDismiss, onHidePoints }: CoachmarkSheetProps) {
  const { t } = useLanguage();
  
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent>
        <SheetHeader>
          <SheetTitle>{t('gamification.aboutPoints')}</SheetTitle>
          <SheetDescription className="space-y-3 pt-4">
            <p>{t('gamification.pointsPrivate')}</p>
            <p>{t('gamification.noLeaderboards')}</p>
            <p>{t('gamification.turnOffAnytime')}</p>
          </SheetDescription>
        </SheetHeader>
        <div className="flex flex-col gap-3 mt-6">
          <Button onClick={onDismiss} className="w-full">
            {t('gamification.ok')}
          </Button>
          <Button variant="outline" onClick={onHidePoints} className="w-full">
            {t('gamification.hidePoints')}
          </Button>
        </div>
      </SheetContent>
    </Sheet>
  );
}
